import { render, staticRenderFns } from "./AccountingProfile.vue?vue&type=template&id=2061bf5a&"
import script from "./AccountingProfile.vue?vue&type=script&lang=js&"
export * from "./AccountingProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports